<rotec-modal-v2 [title]="title" [width]="width" [height]="height" [darkMode]="true">
  <ng-container ngProjectAs="modal-main">
    <form [formGroup]="drillTipForm">
      <div class="drill-tip-modal-content">
        <div class="drill-tip-section image">
          <img
            src="../../assets/img/correction-method/drill-tip/Custom.svg"
            alt="Drill tip image"
          />
        </div>
        <div class="drill-tip-section">
          <div class="drill-tip-item">
            <div class="label">
              <div class="label-icon orange"></div>
              <p translate>Drill Tip Angle</p>
            </div>
            <rotec-number-input-v2
              [onlyAllowDecimals]="false"
              info="°"
              min="0"
              max="180"
              [darkMode]="true"
              [value]="drillTipForm.get('drillTipAngle').value"
              [decOnFocus]="true"
              (valueChange)="onChangeForm($event, 'drillTipAngle')"
            ></rotec-number-input-v2>
          </div>
          <div class="drill-tip-item">
            <div class="label">
              <div class="label-icon blue"></div>
              <p translate>Cross Edge Factor</p>
            </div>
            <rotec-number-input-v2
              [onlyAllowDecimals]="false"
              info="%"
              min="0"
              max="100"
              [darkMode]="true"
              [value]="crossEdgeFactorValue"
              [decOnFocus]="true"
              (valueChange)="onChangeForm($event / 100, 'crossEdgeFactor')"
            ></rotec-number-input-v2>
            <p class="info">* % {{ 'of diameter' | translate }}</p>
          </div>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container ngProjectAs="modal-buttons">
    <div class="drill-tip-modal-buttons">
      <button rotec-button-primary-v2 dark (click)="cancel()">
        {{ 'Cancel' | translate }}
      </button>
      <button rotec-button-active dark [disabled]="!drillTipForm.valid" (click)="save()">
        {{ 'OK' | translate }}
      </button>
    </div>
  </ng-container>
</rotec-modal-v2>
